// extracted by mini-css-extract-plugin
module.exports = {"frame":"Frame_frame__1hg3b","mainPage":"Frame_mainPage__2bUei"};